module.exports = __webpack_public_path__ + "assets/img/LTC021.7ecf916d.png";